<script>
import { Pie, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'

export default {
  extends: Pie,
  mixins: [Pie, mixins.reactiveProp],
  name: 'chart-pie',
  plugins: [ChartDataLabels],
  props: ['chartData', 'options'],
  data () {
    return {
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
